import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import {
  Package, CheckCircle, WarningCircle, XCircle, ArrowLeft, ArrowClockwise,
  Truck, Printer, Barcode, ClipboardText, CaretRight, ArrowCounterClockwise,
} from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import IngresoMercaderiaTab from "@/pages/IngresoMercaderiaTab";

export default function RecepcionMercaderiaPage() {
  return (
    <div className="p-4">
      <div className="flex items-center gap-3 mb-4">
        <Truck size={30} weight="duotone" className="text-[#921A0E]" />
        <div className="flex-1">
          <h1 className="text-2xl font-bold font-heading">Recepción de Mercadería</h1>
        </div>
      </div>
      <IngresoMercaderiaTab />
    </div>
  );
}
